export default [
  {
    name: 'employee-booking',
    title: '預約列表',
    description: '預約列表',
    icon: 'clipboard-list',
  },
  {
    name: 'employee-calendar',
    title: '櫃檯管理',
    description: '櫃檯管理',
    icon: 'calendar',
  },
  {
    name: 'employee-staff',
    title: '我的帳戶',
    description: '我的帳戶',
    icon: 'users-class',
  },
  // {
  //   name: 'employee-check-in',
  //   title: '報到核銷',
  //   description: '報到核銷',
  //   icon: 'calendar',
  // },
]
